import React from 'react';
import { CheckIcon } from 'lucide-react';
import { outcomes } from '../data/offer';
export function Outcomes() {
  return <section id="resultados" className="border-b border-ink-800 bg-ink-900" data-id="element-71" data-mp="1h8eyki5c8fn3">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-72" data-mp="1m8jgmclw9iff">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-flame-500" data-id="element-73" data-mp="1m702osnpnjgt">
          ¿Qué vas a lograr?
        </p>
        <h2 className="max-w-2xl font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-74" data-mp="tkx3acmv6zfd">
          Cuatro resultados, un solo plan
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-75" data-mp="13ibk4dcp9q87">
          {outcomes.map(outcome => <li key={outcome.title} className="rounded-xl border border-ink-700 bg-ink-950 p-6" data-id="element-76" data-mp="1891nxm5h9l0s">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-flame-500" data-id="element-77" data-mp="asmj3zzzpq6l">
                <CheckIcon className="h-5 w-5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-78" data-mp="frpcgn6ly7yq" />
              </span>
              <h3 className="mt-4 font-display text-2xl font-extrabold uppercase text-white" data-id="element-79" data-mp="2xy524z9ul5mo">
                {outcome.title}
              </h3>
              <p className="mt-2 leading-relaxed text-zinc-400" data-id="element-80" data-mp="2t5vexr04ajo3">{outcome.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}